module.exports = __webpack_public_path__ + "static/media/jack.6ccdc3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jack.png
// module id = 77
// module chunks = 0